export enum eSurveyQuestionTypeId {
    dm_truong_id = 1,
    dm_khoi_id = 2,
    dm_he_id = 3,
}